import { VisionHeatmap } from '../../map/heatmap';
import { VisionApplication } from '../../application';
import { VisionMap } from '../../map/map';
import { VisionSpreadingTab } from './spreading';

export class SpreadingMap {
    map!: VisionMap;
    parent: VisionSpreadingTab;
    public heatmap!: VisionHeatmap;
    public infoWindow!: google.maps.InfoWindow;

    constructor(tab: VisionSpreadingTab) {
        this.parent = tab;
        //tab.tabbar.cells('map').attachHTMLString('<div id="spreading_map_id" style="width:100%;height:100%"></div>');
        tab.rightLayout.cells('a').attachHTMLString('<div id="spreading_map_id" style="width:100%;height:100%"></div>');

        this.map = new VisionMap('spreading_map_id');
        this.map.init('spreading_map', this.parent.app.organizationService.dto?.latitude, this.parent.app.organizationService.dto?.longitude).then(() => {
            console.log('Spreading Map Initialized');
            this.heatmap = new VisionHeatmap(this.map.map);
            this.infoWindow = new google.maps.InfoWindow({
                content: "Hello, I'm a popup!",
                pixelOffset: new google.maps.Size(8, -32),
            });

            VisionApplication.getInstance().setMapWorkspace(this.map.map);
            this.map.map.setCenter(new google.maps.LatLng(this.parent.app.organizationService.dto?.latitude, this.parent.app.organizationService.dto?.longitude));
        });
    }
}
